interface ParlorDisplayNoneFooterProps {
  tel: string;
  fax: string;
  address: string;
  copyright: string;
}

export default function ParlorDisplayNoneFooter({
  tel,
  fax,
  address,
  copyright,
}: ParlorDisplayNoneFooterProps) {
  return (
    <footer style={{ display: "none" }}>
      <address>
        TEL : {tel} <br />
        FAX : {fax} <br />
        {address} <br />
        {copyright}
      </address>
    </footer>
  );
}
